import { request } from "../../httpClient";

export const deleteGalleryRequest = async (id) => {
  const res = await request({
    path: "vehicle-gallery/delete",
    method: "POST",
    body: JSON.stringify({ id }),
  });
  return res;
};
